export default {
  props: {
    transaction: {
      type: Object,
      required: true,
    },
  },
  computed: {
    amountDisplay() {
      return `${Number(this.transaction.amount).toLocaleString()} PLN`;
    },
    imageStyleModifiers() {
      return {
        "background-image": `linear-gradient(to top, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0)), url('${this.transaction.plan.background}')`,
      };
    },
  },
};
